import { tempDataPage } from "./commonMobile";
import { filterBaseGameFavourites } from "./favourites";
import { getBasePcode } from "./gamePcode";

function fetchFavourites(mainClass: any): void {
	const request = mainClass.state.useTempData ?
		new Request(tempDataPage + "?page=games-favorites") :
		new Request("/games/favorites");

	let init: any;
	if (!mainClass.state.useTempData)
		init = { credentials: "same-origin" };

	fetch(request, init)
		.then(res => res.json())
		.then(data => {
			if (data.games === "") {
				mainClass.setState({ favouritedGames: [] });
				return;
			}

			const filteredGameList = filterBaseGameFavourites(
				mainClass.state.userdata,
				data.games
			);

			mainClass.setState({ favouritedGames: filteredGameList });
		})
		.catch(error =>
			console.error("Failed to fetch favourites", error)
		);
}

/**
	 * Set in-game roadmap filter
	 * @param e 
	 */
function setLobbyRoadmapFilter(e: React.MouseEvent): void {
	const pcode = e.currentTarget.getAttribute("game");
	const filter = e.currentTarget.getAttribute("filter");
	const { games } = this.state;
	const game = games[pcode];

	const oldFilter = game.activeRoadmapFilter;
	game.activeRoadmapFilter = filter;

	//For desktop multi table
	if (!game.alwaysShowRoadmapText) {
		game.alwaysShowRoadmapText = true;
	}
	// Hide tip if alredy show
	else if (
		filter === oldFilter &&
		game.alwaysShowRoadmapText) {
		game.alwaysShowRoadmapText = false;
	}

	this.setState({ games });
}

function toggleFavourite(e: any): void {
	const isEvent = !!e.currentTarget;

	const pcode = isEvent ? e.currentTarget.getAttribute("pcode") : e.pcode;
	const basePcode = getBasePcode(pcode);
	const favouritedGames = this.state.favouritedGames;

	const idx = favouritedGames.indexOf(pcode);

	//Checks game existence
	const isRemove = idx >= 0;

	if (isRemove)
		favouritedGames.splice(idx, 1);
	else favouritedGames.push(basePcode);

	// console.log("tF pcode", pcode);

	if (!this.state.useTempData) {
		const fetchPostData = {
			nickname: this.state.userdata.user.nickname,
			operatorId: this.state.userdata.user.operatorId,
			properties: isRemove ? "remove" : "add",
			game: basePcode
		};

		fetch("/games/favorites/update", {
			credentials: "same-origin",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(fetchPostData)
		})
			.then(res => res.json())
			.catch(error => {
				this.setState({
					showErrorPage: true,
					errorType: "lostauth",
					errorMessage: ""
				});

				return console.error(error);
			})
			.then(() => { //_data
				console.log(
					isRemove ?
						"tF remove " + pcode :
						"tF add " + pcode
				);
			});
	}

	this.setState({ favouritedGames });
}

export {
	fetchFavourites,
	setLobbyRoadmapFilter,
	toggleFavourite
}